<div class="dialog-box-container">
    <div class="dialog-box-title">حذف از لیست نشان شده ها</div>
    <div class="dialog-box-body">
        آیا از حذف
        <b [textContent]="title"></b>
        از لیست نشان شده ها، مطمئن هستید؟
    </div>
    <div class="dialog-box-container-button">
        <button class="confirm-btn" (click)="removeItem()">تایید</button>
        <button class="cancel-btn" (click)="cancel()">انصراف</button>
    </div>
</div>
